import { ActionFunction } from 'react-router-dom'

import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const updateCollectionOrderAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  return http.action.post(ApiRoutes.collections.updateOrderPath(), {
    collection_id: formData.get('collectionId'),
    start_position: formData.get('startPos'),
    end_position: formData.get('endPos'),
    type: formData.get('type'),
  })
}

export default updateCollectionOrderAction
